const TONE_BY_SCORE = Object.freeze({
  poor: 'destructive',
  moderate: 'warning',
  strong: 'success',
});

/**
 * Contact directory relevance score -> BaseTag tone (aligné sur contact-directory-score-mixin : <3, <6, sinon).
 */
export function getContactDirectoryScoreTone(score) {
  if (typeof score !== 'number' || Number.isNaN(score)) {
    return 'neutral';
  }
  if (score < 3) {
    return TONE_BY_SCORE.poor;
  }
  if (score < 6) {
    return TONE_BY_SCORE.moderate;
  }
  return TONE_BY_SCORE.strong;
}
